export const DEFAULT_VALUES = {
  defaultCountryState: 'LT',
  currencyState: '€',
  isInternationalCountryName: false,
  isDateSelectPreferred: true,
  defaultCardStyle: {
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    border: `1px solid rgba(145, 158, 171, 0.2)`,
    borderRadius: '4px',
  },
  defaultCountry: 'LT',
};
